import { ListboxSelected } from '@/components/Listbox';
import { PeopleCatalogueListbox } from '@/features/featured-people/components/PeopleCatalogueListbox';

type PeopleSelectionDropdownProps = {
  onChange: (value: ListboxSelected) => void;
};

export function PeopleSelectionDropdown({ onChange }: PeopleSelectionDropdownProps) {
  return <PeopleCatalogueListbox mode="single" onChange={onChange} />;
}
